// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../node_modules/ol/ol.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map-container {
  display: flex;
  align-items: stretch;
  width: 100%;
  height: 100%;
}

.map {
  width: 100%;
}

#main-map {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  position: relative;
}

/* Panning Control */
.panning-control {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr;
  gap: 0px 0px;
  top: 5.7em !important;
}

/* Map style */

/* .ol-control button{
  height: 2em !important;
  width: 2em !important;
} */

.ol-control button {
  /* background-color: rgba(183, 200, 0, 0.75); */
  color: #fff;
  width: 22px;
  height: 22px;
  font-size: 18px !important;
}

.ol-control {
  position: absolute;
  background-color: rgba(255,255,255,.4);
  border-radius: 4px;
  padding: 1px;
}

.ol-zoom-selected {
  left: 0.5em;
  top: 5.7em
}

.ol-control button:hover {
  background-color: inherit;
  color: white;
}
.ol-control button:focus {
  background-color: inherit;
  color: white;
} 

.ol-zoom-extent {
  top:4.1em
}

/* .ol-zoom {
  left: 60px;
} */

.ol-layerswitcher-dof {
  left: 0.5em;
  top: 7.8em;
}

.ol-layerswitcher-objekti {
  top: 9.4em;
  left: 0.5em;
}

.ol-layerswitcher-kc {
  top: 11em;
  left: 0.5em;
}

.ol-button-resize {
  top: 0.5em;
  left: 2.6em;
}

.ol-custom-control {
  position: absolute;
  z-index: 1;
}

/* Long press (touch GFI) */

.ol-viewport {
  -webkit-touch-callout: none;
}

.map-longpress-ring {
  position: absolute;
  width: 56px;
  height: 56px;
  margin: -28px 0 0 -28px;
  border-radius: 50%;
  border: 3px solid rgba(255, 255, 255, 0.95);
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.3);
  pointer-events: none;
  z-index: 10;
  /* delay so quick taps and pans don't flash it */
  animation: map-longpress-ring 350ms ease-out 150ms both;
}

@keyframes map-longpress-ring {
  from {
    transform: scale(0.3);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

/* OL Popup */

.ol-react-popup {
  position: absolute;
  background-color: white;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  /* border: 1px solid #cccccc; */
  bottom: 12px;
  left: -50px;
}
.ol-react-popup:after,
.ol-react-popup:before {
  top: 100%;
  border: solid transparent;
  content: ' ';
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}
.ol-react-popup:after {
  border-top-color: white;
  border-width: 10px;
  left: 48px;
  margin-left: -10px;
}
.ol-react-popup:before {
  border-top-color: #cccccc;
  border-width: 11px;
  left: 48px;
  margin-left: -11px;
}

/* OL MousePosition Control */

.ol-mouse-position-htrs96 {
  font-size: 0.8em;
  text-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff,
    1px 1px 0 #fff;
  bottom: 40px;
  right: 10px;
  position: absolute;
}
.ol-mouse-position-htrs96:before {
  content: 'HTRS96/TM: ';
}

.ol-mouse-position-wgs84 {
  font-size: 0.8em;
  text-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff,
    1px 1px 0 #fff;
  bottom: 25px;
  right: 10px;
  position: absolute;
}
.ol-mouse-position-wgs84:before {
  content: 'WGS84: ';
}

/* OL ZoomSlider Control */
.ol-zoomslider {
  top: 4.5em;
  left: 0.5em;
  height: 200px;
}

/* ol-ext LayerSwitcherImage */

.ol-layerswitcher-image button {
  background-color: white;
  background-image: url('../images/warped-layers.svg') !important;
  /*url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAACE1BMVEX///8A//8AgICA//8AVVVAQID///8rVVVJtttgv98nTmJ2xNgkW1ttyNsmWWZmzNZYxM4gWGgeU2JmzNNr0N1Rwc0eU2VXxdEhV2JqytQeVmMhVmNoydUfVGUgVGQfVGQfVmVqy9hqy9dWw9AfVWRpydVry9YhVmMgVGNUw9BrytchVWRexdGw294gVWQgVmUhVWPd4N6HoaZsy9cfVmQgVGRrytZsy9cgVWQgVWMgVWRsy9YfVWNsy9YgVWVty9YgVWVry9UgVWRsy9Zsy9UfVWRsy9YgVWVty9YgVWRty9Vsy9aM09sgVWRTws/AzM0gVWRtzNYgVWRuy9Zsy9cgVWRGcHxty9bb5ORbxdEgVWRty9bn6OZTws9mydRfxtLX3Nva5eRix9NFcXxOd4JPeINQeIMiVmVUws9Vws9Vw9BXw9BYxNBaxNBbxNBcxdJexdElWWgmWmhjyNRlx9IqXGtoipNpytVqytVryNNrytZsjZUuX210k5t1y9R2zNR3y9V4lp57zth9zdaAnKOGoaeK0NiNpquV09mesrag1tuitbmj1tuj19uktrqr2d2svcCu2d2xwMO63N+7x8nA3uDC3uDFz9DK4eHL4eLN4eIyYnDX5OM5Z3Tb397e4uDf4uHf5uXi5ePi5+Xj5+Xk5+Xm5+Xm6OY6aHXQ19fT4+NfhI1Ww89gx9Nhx9Nsy9ZWw9Dpj2abAAAAWnRSTlMAAQICAwQEBgcIDQ0ODhQZGiAiIyYpKywvNTs+QklPUlNUWWJjaGt0dnd+hIWFh4mNjZCSm6CpsbW2t7nDzNDT1dje5efr7PHy9PT29/j4+Pn5+vr8/f39/f6DPtKwAAABTklEQVR4Xr3QVWPbMBSAUTVFZmZmhhSXMjNvkhwqMzMzMzPDeD+xASvObKePPa+ffHVl8PlsnE0+qPpBuQjVJjno6pZpSKXYl7/bZyFaQxhf98hHDKEppwdWIW1frFnrxSOWHFfWesSEWC6R/P4zOFrix3TzDFLlXRTR8c0fEEJ1/itpo7SVO9Jdr1DVxZ0USyjZsEY5vZfiiAC0UoTGOrm9PZLuRl8X+Dq1HQtoFbJZbv61i+Poblh/97TC7n0neCcK0ETNUrz1/xPHf+DNAW9Ac6t8O8WH3Vp98f5lCaYKAOFZMLyHL4Y0fe319idMNgMMp+zWVSybUed/+/h7I4wRAG1W6XDy4XmjR9HnzvDRZXUAYDFOhC1S/Hh+fIXxen+eO+AKqbs+wAo30zDTDvDxKoJN88sjUzDFAvBzEUGFsnADoIvAJzoh2BZ8sner+Ke/vwECuQAAAABJRU5ErkJggg==");*/
  background-position: center;
  background-repeat: no-repeat;
  float: right;
  height: 42px;
  width: 42px;
  display: none;
  filter: hue-rotate(100deg);
}

.ol-layerswitcher-image li.ol-layer-hidden {
  opacity: 1;
  border-color: rgba(85, 85, 85, 0.5);
}

.ol-layerswitcher-image li.select,
.ol-layerswitcher-image li.ol-visible {
  border: 3px solid rgb(183, 200, 0);
}

/* Measure Control */
.ol-measure {
  position: absolute;
  top: 10em;
  left: 0.5em;
}

/* Download ShapeFile Control */
/* .ol-download-shape {
  position: absolute;
  top: 14em;
  left: 0.5em;
} */

/* Sidebar Control Button */

.ol-sidebar-control {
  position: relative;
  width: 40px;
  height: 40px;
  border-width: 0px;
  padding: 0px;
}

.ol-sidebar-control > button {
  margin: 0px;
  height: 100%;
  width: 100%;
}
.ol-sidebar-control > button:hover {
  /* background-color: rgba(255,211,58, 0.9); */
}

.ol-bar-sidebar {
  position: relative !important;
}

.ol-thumb-control > button {
  width: 60px;
  height: 60px;
}

.ol-thumb-control.ol-active > button {
  /* background-color: rgb(136,149,0) ; */
}

#center-marker-btn:not(:hover) {
  box-shadow: 0px 0px 0px 0px;
}

#center-marker-btn-active {
  box-shadow: 0px 0px 0px 0px;
}

#print-btn:not(:hover) {
  box-shadow: 0px 0px 0px 0px;
}

#print-btn:hover {
  border-radius: 0px;
}

#geolocate-btn:hover {
  border-radius: 0px;
}

#center-marker-btn:hover {
  border-radius: 0px;
}

#center-marker-btn:hover {
  border-radius: 0px;
}

.MuiTabScrollButton-root {
  width: fit-content;
}

/* .ol-full-screen-true:not(:active) {
  background-color: inherit;
} */

/* Animation on all browsers */
@-webkit-keyframes scale-up-down {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}
@-moz-keyframes scale-up-down {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}
@-o-keyframes scale-up-down {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes scale-up-down {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

/* Vendor prefixes for keyframes */
@-webkit-keyframes flash-opacity {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.65;
  }
}
@-moz-keyframes flash-opacity {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.65;
  }
}
@-o-keyframes flash-opacity {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.65;
  }
}
@keyframes flash-opacity {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.65;
  }
}

/* Ensure browser compatibility for animation */
.gs-info-card-draggable > .MuiCard-root {
  -webkit-animation: scale-up-down 0.5s ease-in-out, flash-opacity 0.5s ease-in-out;
  -moz-animation: scale-up-down 0.5s ease-in-out, flash-opacity 0.5s ease-in-out;
  -o-animation: scale-up-down 0.5s ease-in-out, flash-opacity 0.5s ease-in-out;
  animation: scale-up-down 0.5s ease-in-out, flash-opacity 0.5s ease-in-out;
}
.MuiTabs-root .MuiTabScrollButton-root:first-child {
  border-right: 0.1px solid lightgray;
}

.MuiTabs-root .MuiTabScrollButton-root:last-child {
  border-left: 0.1px solid lightgray;
}
`, "",{"version":3,"sources":["webpack://./src/styles/map.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,kCAAkC;EAClC,+BAA+B;EAC/B,YAAY;EACZ,qBAAqB;AACvB;;AAEA,cAAc;;AAEd;;;GAGG;;AAEH;EACE,+CAA+C;EAC/C,WAAW;EACX,WAAW;EACX,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE;AACF;;AAEA;;GAEG;;AAEH;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA,2BAA2B;;AAE3B;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,2CAA2C;EAC3C,wCAAwC;EACxC,oBAAoB;EACpB,WAAW;EACX,gDAAgD;EAChD,uDAAuD;AACzD;;AAEA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA,aAAa;;AAEb;EACE,kBAAkB;EAClB,uBAAuB;EACvB,wCAAwC;EACxC,mBAAmB;EACnB,+BAA+B;EAC/B,YAAY;EACZ,WAAW;AACb;AACA;;EAEE,SAAS;EACT,yBAAyB;EACzB,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;AAEA,6BAA6B;;AAE7B;EACE,gBAAgB;EAChB;kBACgB;EAChB,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB;kBACgB;EAChB,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,UAAU;EACV,WAAW;EACX,aAAa;AACf;;AAEA,8BAA8B;;AAE9B;EACE,uBAAuB;EACvB,+DAA+D;EAC/D,y4CAAy4C;EACz4C,2BAA2B;EAC3B,4BAA4B;EAC5B,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,mCAAmC;AACrC;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA,+BAA+B;AAC/B;;;;GAIG;;AAEH,2BAA2B;;AAE3B;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;AACb;AACA;EACE,6CAA6C;AAC/C;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;GAEG;;AAEH,8BAA8B;AAC9B;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;AACF;;AAEA,+CAA+C;AAC/C;EACE,iFAAiF;EACjF,8EAA8E;EAC9E,4EAA4E;EAC5E,yEAAyE;AAC3E;AACA;EACE,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;AACpC","sourcesContent":["@import 'NodeModules/ol/ol.css';\n\n.map-container {\n  display: flex;\n  align-items: stretch;\n  width: 100%;\n  height: 100%;\n}\n\n.map {\n  width: 100%;\n}\n\n#main-map {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n\n/* Panning Control */\n.panning-control {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  grid-template-rows: 1fr 1fr 1fr;\n  gap: 0px 0px;\n  top: 5.7em !important;\n}\n\n/* Map style */\n\n/* .ol-control button{\n  height: 2em !important;\n  width: 2em !important;\n} */\n\n.ol-control button {\n  /* background-color: rgba(183, 200, 0, 0.75); */\n  color: #fff;\n  width: 22px;\n  height: 22px;\n  font-size: 18px !important;\n}\n\n.ol-control {\n  position: absolute;\n  background-color: rgba(255,255,255,.4);\n  border-radius: 4px;\n  padding: 1px;\n}\n\n.ol-zoom-selected {\n  left: 0.5em;\n  top: 5.7em\n}\n\n.ol-control button:hover {\n  background-color: inherit;\n  color: white;\n}\n.ol-control button:focus {\n  background-color: inherit;\n  color: white;\n} \n\n.ol-zoom-extent {\n  top:4.1em\n}\n\n/* .ol-zoom {\n  left: 60px;\n} */\n\n.ol-layerswitcher-dof {\n  left: 0.5em;\n  top: 7.8em;\n}\n\n.ol-layerswitcher-objekti {\n  top: 9.4em;\n  left: 0.5em;\n}\n\n.ol-layerswitcher-kc {\n  top: 11em;\n  left: 0.5em;\n}\n\n.ol-button-resize {\n  top: 0.5em;\n  left: 2.6em;\n}\n\n.ol-custom-control {\n  position: absolute;\n  z-index: 1;\n}\n\n/* Long press (touch GFI) */\n\n.ol-viewport {\n  -webkit-touch-callout: none;\n}\n\n.map-longpress-ring {\n  position: absolute;\n  width: 56px;\n  height: 56px;\n  margin: -28px 0 0 -28px;\n  border-radius: 50%;\n  border: 3px solid rgba(255, 255, 255, 0.95);\n  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.3);\n  pointer-events: none;\n  z-index: 10;\n  /* delay so quick taps and pans don't flash it */\n  animation: map-longpress-ring 350ms ease-out 150ms both;\n}\n\n@keyframes map-longpress-ring {\n  from {\n    transform: scale(0.3);\n    opacity: 0;\n  }\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n/* OL Popup */\n\n.ol-react-popup {\n  position: absolute;\n  background-color: white;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);\n  border-radius: 10px;\n  /* border: 1px solid #cccccc; */\n  bottom: 12px;\n  left: -50px;\n}\n.ol-react-popup:after,\n.ol-react-popup:before {\n  top: 100%;\n  border: solid transparent;\n  content: ' ';\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none;\n}\n.ol-react-popup:after {\n  border-top-color: white;\n  border-width: 10px;\n  left: 48px;\n  margin-left: -10px;\n}\n.ol-react-popup:before {\n  border-top-color: #cccccc;\n  border-width: 11px;\n  left: 48px;\n  margin-left: -11px;\n}\n\n/* OL MousePosition Control */\n\n.ol-mouse-position-htrs96 {\n  font-size: 0.8em;\n  text-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff,\n    1px 1px 0 #fff;\n  bottom: 40px;\n  right: 10px;\n  position: absolute;\n}\n.ol-mouse-position-htrs96:before {\n  content: 'HTRS96/TM: ';\n}\n\n.ol-mouse-position-wgs84 {\n  font-size: 0.8em;\n  text-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff,\n    1px 1px 0 #fff;\n  bottom: 25px;\n  right: 10px;\n  position: absolute;\n}\n.ol-mouse-position-wgs84:before {\n  content: 'WGS84: ';\n}\n\n/* OL ZoomSlider Control */\n.ol-zoomslider {\n  top: 4.5em;\n  left: 0.5em;\n  height: 200px;\n}\n\n/* ol-ext LayerSwitcherImage */\n\n.ol-layerswitcher-image button {\n  background-color: white;\n  background-image: url('../images/warped-layers.svg') !important;\n  /*url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAACE1BMVEX///8A//8AgICA//8AVVVAQID///8rVVVJtttgv98nTmJ2xNgkW1ttyNsmWWZmzNZYxM4gWGgeU2JmzNNr0N1Rwc0eU2VXxdEhV2JqytQeVmMhVmNoydUfVGUgVGQfVGQfVmVqy9hqy9dWw9AfVWRpydVry9YhVmMgVGNUw9BrytchVWRexdGw294gVWQgVmUhVWPd4N6HoaZsy9cfVmQgVGRrytZsy9cgVWQgVWMgVWRsy9YfVWNsy9YgVWVty9YgVWVry9UgVWRsy9Zsy9UfVWRsy9YgVWVty9YgVWRty9Vsy9aM09sgVWRTws/AzM0gVWRtzNYgVWRuy9Zsy9cgVWRGcHxty9bb5ORbxdEgVWRty9bn6OZTws9mydRfxtLX3Nva5eRix9NFcXxOd4JPeINQeIMiVmVUws9Vws9Vw9BXw9BYxNBaxNBbxNBcxdJexdElWWgmWmhjyNRlx9IqXGtoipNpytVqytVryNNrytZsjZUuX210k5t1y9R2zNR3y9V4lp57zth9zdaAnKOGoaeK0NiNpquV09mesrag1tuitbmj1tuj19uktrqr2d2svcCu2d2xwMO63N+7x8nA3uDC3uDFz9DK4eHL4eLN4eIyYnDX5OM5Z3Tb397e4uDf4uHf5uXi5ePi5+Xj5+Xk5+Xm5+Xm6OY6aHXQ19fT4+NfhI1Ww89gx9Nhx9Nsy9ZWw9Dpj2abAAAAWnRSTlMAAQICAwQEBgcIDQ0ODhQZGiAiIyYpKywvNTs+QklPUlNUWWJjaGt0dnd+hIWFh4mNjZCSm6CpsbW2t7nDzNDT1dje5efr7PHy9PT29/j4+Pn5+vr8/f39/f6DPtKwAAABTklEQVR4Xr3QVWPbMBSAUTVFZmZmhhSXMjNvkhwqMzMzMzPDeD+xASvObKePPa+ffHVl8PlsnE0+qPpBuQjVJjno6pZpSKXYl7/bZyFaQxhf98hHDKEppwdWIW1frFnrxSOWHFfWesSEWC6R/P4zOFrix3TzDFLlXRTR8c0fEEJ1/itpo7SVO9Jdr1DVxZ0USyjZsEY5vZfiiAC0UoTGOrm9PZLuRl8X+Dq1HQtoFbJZbv61i+Poblh/97TC7n0neCcK0ETNUrz1/xPHf+DNAW9Ac6t8O8WH3Vp98f5lCaYKAOFZMLyHL4Y0fe319idMNgMMp+zWVSybUed/+/h7I4wRAG1W6XDy4XmjR9HnzvDRZXUAYDFOhC1S/Hh+fIXxen+eO+AKqbs+wAo30zDTDvDxKoJN88sjUzDFAvBzEUGFsnADoIvAJzoh2BZ8sner+Ke/vwECuQAAAABJRU5ErkJggg==\");*/\n  background-position: center;\n  background-repeat: no-repeat;\n  float: right;\n  height: 42px;\n  width: 42px;\n  display: none;\n  filter: hue-rotate(100deg);\n}\n\n.ol-layerswitcher-image li.ol-layer-hidden {\n  opacity: 1;\n  border-color: rgba(85, 85, 85, 0.5);\n}\n\n.ol-layerswitcher-image li.select,\n.ol-layerswitcher-image li.ol-visible {\n  border: 3px solid rgb(183, 200, 0);\n}\n\n/* Measure Control */\n.ol-measure {\n  position: absolute;\n  top: 10em;\n  left: 0.5em;\n}\n\n/* Download ShapeFile Control */\n/* .ol-download-shape {\n  position: absolute;\n  top: 14em;\n  left: 0.5em;\n} */\n\n/* Sidebar Control Button */\n\n.ol-sidebar-control {\n  position: relative;\n  width: 40px;\n  height: 40px;\n  border-width: 0px;\n  padding: 0px;\n}\n\n.ol-sidebar-control > button {\n  margin: 0px;\n  height: 100%;\n  width: 100%;\n}\n.ol-sidebar-control > button:hover {\n  /* background-color: rgba(255,211,58, 0.9); */\n}\n\n.ol-bar-sidebar {\n  position: relative !important;\n}\n\n.ol-thumb-control > button {\n  width: 60px;\n  height: 60px;\n}\n\n.ol-thumb-control.ol-active > button {\n  /* background-color: rgb(136,149,0) ; */\n}\n\n#center-marker-btn:not(:hover) {\n  box-shadow: 0px 0px 0px 0px;\n}\n\n#center-marker-btn-active {\n  box-shadow: 0px 0px 0px 0px;\n}\n\n#print-btn:not(:hover) {\n  box-shadow: 0px 0px 0px 0px;\n}\n\n#print-btn:hover {\n  border-radius: 0px;\n}\n\n#geolocate-btn:hover {\n  border-radius: 0px;\n}\n\n#center-marker-btn:hover {\n  border-radius: 0px;\n}\n\n#center-marker-btn:hover {\n  border-radius: 0px;\n}\n\n.MuiTabScrollButton-root {\n  width: fit-content;\n}\n\n/* .ol-full-screen-true:not(:active) {\n  background-color: inherit;\n} */\n\n/* Animation on all browsers */\n@-webkit-keyframes scale-up-down {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n@-moz-keyframes scale-up-down {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n@-o-keyframes scale-up-down {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n@keyframes scale-up-down {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.05);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n/* Vendor prefixes for keyframes */\n@-webkit-keyframes flash-opacity {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.65;\n  }\n}\n@-moz-keyframes flash-opacity {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.65;\n  }\n}\n@-o-keyframes flash-opacity {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.65;\n  }\n}\n@keyframes flash-opacity {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.65;\n  }\n}\n\n/* Ensure browser compatibility for animation */\n.gs-info-card-draggable > .MuiCard-root {\n  -webkit-animation: scale-up-down 0.5s ease-in-out, flash-opacity 0.5s ease-in-out;\n  -moz-animation: scale-up-down 0.5s ease-in-out, flash-opacity 0.5s ease-in-out;\n  -o-animation: scale-up-down 0.5s ease-in-out, flash-opacity 0.5s ease-in-out;\n  animation: scale-up-down 0.5s ease-in-out, flash-opacity 0.5s ease-in-out;\n}\n.MuiTabs-root .MuiTabScrollButton-root:first-child {\n  border-right: 0.1px solid lightgray;\n}\n\n.MuiTabs-root .MuiTabScrollButton-root:last-child {\n  border-left: 0.1px solid lightgray;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
